import styled from 'styled-components';

interface OffersProps {
  planLength: number;
}

const Offers = styled.div<OffersProps>`
  width: 1200px;
  height: 280px;
  display: grid;
  grid-template-columns: 275px 1fr 1fr 1fr ${props => props.planLength > 3 && '1fr'};
  grid-template-rows: 280px;
  background-color: ${props => props.theme.color.backgroundRush};
  border-radius: 40px;
  margin: 0 auto;
  margin-bottom: 40px;
`;

export const Styled = {
  Offers,
};
